
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("ejnrO", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $1a9034d89cb417c2$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Portuguese (Brazil)
var $1a9034d89cb417c2$export$2e2bcd8739ae039 = {
    'fabric.editor.headingLink.ascSortingLabel': 'ascendente',
    'fabric.editor.headingLink.copied': 'Copiado!',
    'fabric.editor.headingLink.copyAnchorLink': "Copiar link para cabe\xe7alho",
    'fabric.editor.headingLink.copyAriaLabel': 'Copiar',
    'fabric.editor.headingLink.descSortingLabel': 'descendente',
    'fabric.editor.headingLink.failedToCopy': "Falha na c\xf3pia",
    'fabric.editor.headingLink.noneSortingLabel': 'nenhum',
    'fabric.editor.inlineComment.marker.end': "fim de coment\xe1rio em linha",
    'fabric.editor.inlineComment.marker.start': "in\xedcio de coment\xe1rio em linha"
};

});


//# sourceMappingURL=pt_BR.c1845a25.js.map
